
export class Config {
    pageSizeOptionsList: any = [10, 50, 100];
}